import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import RoleProfileEditor from "@/components/profile/RoleProfileEditor";
import type { RoleKey } from "@/components/profile/roleProfileSchema";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

const ROLE_PRIORITY: RoleKey[] = [
  "partner",
  "consultant",
  "broker",
  "lender",
  "seller",
  "buyer",
];

const ROLE_DASHBOARD: Record<RoleKey, string> = {
  buyer: "/buyer/dashboard",
  seller: "/seller/dashboard",
  consultant: "/dashboard/consultant",
  broker: "/dashboard/broker",
  lender: "/dashboard/lender",
  partner: "/internal-partners",
};

export default function UserProfile() {
  const { user, loading } = useAuth() as any;
  const { language } = useLanguage();
  const lang = (language as "en" | "fr") || "en";

  if (loading) {
    return <div className="flex items-center justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  }

  const roles: string[] = (user?.roles || []) as string[];

  // Map "internal-partners" Firebase role to "partner" schema key
  const normalizedRoles = roles.map((r) =>
    r === "internal-partners" ? "partner" : r
  );

  const role = (ROLE_PRIORITY.find((r) =>
    normalizedRoles.includes(r)
  ) || "buyer") as RoleKey;

  const backHref = ROLE_DASHBOARD[role];
  const backLabel = lang === "fr" ? "Retour au tableau de bord" : "Back to dashboard";

  return (
    <div className="container mx-auto p-6 max-w-5xl">
      <Button asChild variant="ghost" size="sm" className="mb-4">
        <Link to={backHref}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          {backLabel}
        </Link>
      </Button>
      <RoleProfileEditor role={role} />
    </div>
  );
}
